import { render } from "./FinancialInputsView.vue?vue&type=template&id=97b21678&ts=true"
import script from "./FinancialInputsView.vue?vue&type=script&lang=ts"
export * from "./FinancialInputsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__